export default __webpack_public_path__ + "static/media/copper hat.9f75a37b.svg";